import Shop from '../../models/shop'
import { ShopAction } from '../actions/shop'

const initialState: Props = {
  loaded: false,
  snackOpen: false,
  shop: new Shop(),
}

interface Props {
  loaded: boolean
  snackOpen: boolean
  shop: Shop
}

const reducer = (state: Props = initialState, action: ShopAction): Props => {
  switch (action.type) {
    case 'RECEIVE_SHOP': {
      return {
        ...state,
        ...action.shop,
        loaded: true,
      }
    }
    case 'COMPLETE_UPDATE_SHOP': {
      return {
        ...state,
        snackOpen: true,
      }
    }
    case 'CLOSE_SHOP_SNACK': {
      return {
        ...state,
        snackOpen: false,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
